import { Modal } from 'components/Modal'
import Button from 'new-components/Button'
import { FiAlertCircle } from 'react-icons/fi'
import { UnavailableProduct } from '../../hooks/useProductSubstitution'
import * as Styles from './styles'

interface UnavailableProductModalProps {
  isOpen: boolean
  products: UnavailableProduct[]
  onConfirm: () => void
}

export default function UnavailableProductModal({ isOpen, products, onConfirm }: UnavailableProductModalProps) {
  if (products.length === 0) return null

  return (
    <Modal isOpened={isOpen} onRequestClose={onConfirm}>
      <Styles.Container>
        <Styles.Header>
          <div className="icon-wrapper">
            <FiAlertCircle size={24} color="#dc2626" />
          </div>
          <div>
            <h1>Produtos Indisponíveis no Modelo</h1>
            <p>
              Os seguintes produtos do modelo salvo estão inativos ou indisponíveis e não foram encontradas
              alternativas automáticas.
            </p>
          </div>
        </Styles.Header>

        <Styles.ProductsList>
          {products.map((product) => (
            <Styles.ProductCard key={product.id}>
              {product.image_url && <img src={product.image_url} alt={product.name} />}
              <div>
                <h2>{product.name}</h2>
                {product.translated_name && <span className="translated-name">{product.translated_name}</span>}
                <Styles.TagsContainer>
                  {product.class_name && <Styles.Tag>{product.class_name}</Styles.Tag>}
                  {product.shape_name && <Styles.Tag>{product.shape_name}</Styles.Tag>}
                  <Styles.UnavailableTag>Indisponível</Styles.UnavailableTag>
                </Styles.TagsContainer>
              </div>
            </Styles.ProductCard>
          ))}
        </Styles.ProductsList>

        <Styles.WarningBox>
          <p>
            <strong>Atenção:</strong> Estes produtos serão removidos da prescrição atual. Você precisará selecionar
            manualmente produtos alternativos através da busca.
          </p>
        </Styles.WarningBox>

        <Styles.Footer>
          <Button background="primary" onClick={onConfirm}>
            Entendi, remover produtos indisponíveis
          </Button>
        </Styles.Footer>
      </Styles.Container>
    </Modal>
  )
}
